import { CategoryProductStats } from '@/types/Category';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  totalNumberOfProductsInACategory: null,
  currentCategoryProductsCount: null,
} as CategoryProductStats;

const CategoryProductStatsSlice = createSlice({
  name: 'CategoryProductStatsSlice',
  initialState,
  reducers: {
    setCategoryProductStats(
      state,
      {
        payload: { currentCategoryName, totalNumberOfProductsInACategory, currentCategoryProductsCount },
      }: PayloadAction<CategoryProductStats>
    ) {
      state.currentCategoryName = currentCategoryName;
      state.totalNumberOfProductsInACategory = totalNumberOfProductsInACategory;
      state.currentCategoryProductsCount = currentCategoryProductsCount;
    },
  },
});

export const { setCategoryProductStats } = CategoryProductStatsSlice.actions;
export default CategoryProductStatsSlice;
